module.exports = __webpack_public_path__ + "static/keyboardFocus1-868ed908668294f1042fa2a32f315a54.gif";